"use client";

import React from "react";
import { Button } from "@west-tennessee-consulting/ui";
import { Info, ChevronRight } from "lucide-react";

interface NoCompanyStepProps {
  onClose: () => void;
  onSearchForCompany: () => void;
}

export function NoCompanyStep({ onClose, onSearchForCompany }: NoCompanyStepProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-start gap-3 p-4 bg-blue-50 dark:bg-blue-950/40 border border-blue-200 dark:border-blue-800 rounded">
        <Info className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
        <div>
          <div className="font-medium text-blue-900 dark:text-blue-200">No Company Linked</div>
          <div className="text-sm text-blue-800 dark:text-blue-200 mt-1">
            This contact doesn&apos;t have a company linked yet. You can search for a company and
            import decision makers from it, which will also link this contact to that company.
          </div>
        </div>
      </div>

      <div className="flex gap-2">
        <Button variant="outline" onClick={onClose} className="flex-1">
          Cancel
        </Button>
        <Button onClick={onSearchForCompany} className="flex-1">
          Search for Company
          <ChevronRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </div>
  );
}
